import http from "infra/http";
import { useMutation } from "react-query";

function useToogleFormaPagamento(id: string, tenantId: string) {
  return useMutation(
    [`/v1/forma-pagamento/:id/ativo-inativo`],
    async (active: boolean) => {
      if (active) {
        return http.put(
          `/v1/forma-pagamento/${id}/ativar`,
          {},
          {
            headers: {
              tenant: tenantId,
            },
          }
        );
      }

      return http.put(
        `/v1/forma-pagamento/${id}/desativar`,
        {},
        {
          headers: {
            tenant: tenantId,
          },
        }
      );
    }
  );
}

export default useToogleFormaPagamento;
